import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
    addingItems: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(user_app => ({
        value: user_app.ID,
        label: user_app.email,
      }))
    },
    getAddingItems(state) {
      return state.addingItems.map(user_app => ({
        value: user_app.ID,
        label: user_app.email,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setDataAdding(state, value) {
      state.addingItems = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/user_app', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async getAllForAdding({ commit }, params) {
      const { data } = await axios.get('v1/user_app', { params })

      if (!data) {
        return []
      }

      commit('setDataAdding', data.data)
      return data
    },

    async delete(_, id) {
      const { data } = await axios.delete(`v1/user_app/${id}`)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/user_app/${id}`, params)

      return data
    },

    async getEmail(_, id) {
      const { data } = await axios.get(`v1/users_app/${id}`)

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
